import React from "react";
import { styled } from "@mui/material";
import { replaceBracesKey, toNumericString } from "../../helpers/formatter";
import { useTranslation } from "../../helpers/i18n";

interface Props {
  // TODO: unify averageTotalSavingsPrefix
  averageTotalSavingsPrefix: "up_to" | "exact";
  averageTotalSavingsAmount: number;
  averageTotalSavingsCurrency: string;
  color?: string;
}
const Content = styled("span")<Pick<Props, "color">>(({ theme, color }) => ({
  color: color || theme.palette.success.main,
}));

export function useSavingsAmount({
  averageTotalSavingsAmount,
  averageTotalSavingsCurrency,
  averageTotalSavingsPrefix,
}: Partial<
  Pick<
    Props,
    | "averageTotalSavingsAmount"
    | "averageTotalSavingsCurrency"
    | "averageTotalSavingsPrefix"
  >
>) {
  const { t } = useTranslation();

  if (!averageTotalSavingsAmount) {
    return { savingsAmount: "" };
  }

  const savingsAmount = replaceBracesKey(
    t(
      averageTotalSavingsPrefix === "exact"
        ? "discounts_save"
        : "discounts_up_to_savings",
    ),
    {
      key: "currency",
      value: averageTotalSavingsCurrency || "$",
    },
  );
  return {
    savingsAmount: replaceBracesKey(savingsAmount, {
      key: "amount",
      value: toNumericString(averageTotalSavingsAmount),
    }),
  };
}

const EarningsBox: React.FunctionComponent<Props> = ({
  color,
  averageTotalSavingsAmount,
  averageTotalSavingsCurrency,
  averageTotalSavingsPrefix,
}) => {
  const { savingsAmount } = useSavingsAmount({
    averageTotalSavingsAmount,
    averageTotalSavingsCurrency,
    averageTotalSavingsPrefix,
  });
  return averageTotalSavingsAmount ? (
    <Content color={color}>{savingsAmount}</Content>
  ) : (
    <></>
  );
};

export default EarningsBox;
